import React from 'react';
import { useTranslation } from 'react-i18next';

const GradientButton = ({
  children,
  variant = 'primary',
  href,
  onClick,
  className = '',
  trackingEvent = null,
  trackingLabel = '',
  ...props
}) => {
  const { i18n } = useTranslation();

  // Function to handle Google Analytics tracking
  const handleTracking = () => {
    if (trackingEvent && typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', trackingEvent, {
        'event_category': 'engagement',
        'event_label': trackingLabel,
        'language': i18n.language,
        'page_location': window.location.pathname
      });
      console.log('GA4 Event Tracked:', trackingEvent, {
        label: trackingLabel,
        language: i18n.language,
        page: window.location.pathname
      });
    }
  };
  // Base styles for all buttons with animated gradient
  const baseStyles = `
    gradient-button
    inline-flex items-center justify-center
    rounded-[11px] min-w-[132px] px-9 py-4
    text-base leading-[19px] font-[500] text-white
    font-sans font-bold
    focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring
    disabled:pointer-events-none disabled:opacity-50
  `;

  // Gradient variants using CSS custom properties for smooth animations
  const variants = {
    primary: 'gradient-button-primary',
    secondary: 'gradient-button-secondary',
  };

  const buttonClasses = `${baseStyles} ${variants[variant]} ${className}`.trim().replace(/\s+/g, ' ');

  // If href is provided, render as anchor tag
  if (href) {
    return (
      <a
        href={href}
        className={buttonClasses}
        target={href.startsWith('http') ? '_blank' : undefined}
        rel={href.startsWith('http') ? 'noopener noreferrer' : undefined}
        onClick={handleTracking}
        {...props}
      >
        {children}
      </a>
    );
  }

  // Otherwise render as button
  return (
    <button
      onClick={(e) => {
        handleTracking();
        if (onClick) onClick(e);
      }}
      className={buttonClasses}
      {...props}
    >
      {children}
    </button>
  );
};

export default GradientButton;
